module.exports = __webpack_public_path__ + "assets/logininfor.182c8103.svg";